import { axios } from 'lib/axios'
import { endpoints } from 'utils/endpoints'
import { useQuery } from '@tanstack/react-query'
import { ApiKey } from 'features/incidents/components/enums'

export type ClaimListParam = {
  planId: number
}

export const getResolvedClaimsInPlan = async (params: ClaimListParam) => {
  return axios.get(endpoints.getResolvedClaimsInPlanHistory, { params })
}

export const useGetClaimsInPlan = (params: ClaimListParam) => {
  return useQuery([ApiKey.PlanClaims, ApiKey.list], () => getResolvedClaimsInPlan(params))
}
